import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './pages/App';
import reportWebVitals from './reportWebVitals';

import store from './store';

import './styles.less';

const resizeObserverLoopErr = /ResizeObserver loop completed with undelivered notifications/;
const originalOnError = window.onerror;
window.onerror = function (...args) {
  const [message] = args;
  if (typeof message === 'string' && resizeObserverLoopErr.test(message)) {
    return true;
  }
  if (typeof originalOnError === 'function') {
    return originalOnError.apply(window, args);
  }
  return false;
};

if (typeof (window as any).ResizeObserver !== 'undefined') {
  try {
    const RO = (window as any).ResizeObserver;
    const wrapped = new Proxy(RO, {
      construct(target: any, args: any) {
        const [callback] = args;
        const safeCallback = (entries: any[], observer: any) => {
          try {
            window.requestAnimationFrame(() => {
              try {
                callback(entries, observer);
              } catch {
                /* noop */
              }
            });
          } catch {
            /* noop */
          }
        };
        return new target(safeCallback, args[1]);
      },
    });
    (window as any).ResizeObserver = wrapped;
  } catch {
    /* noop */
  }
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// const root = ReactDOM.createRoot((

//     ),
//     document.getElementById('root')),
// );

reportWebVitals();
